import { Box, Button, Modal, Slider, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import Cropper from "react-easy-crop";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { AddCircleOutlineOutlined } from "@mui/icons-material";

const styles = {
  modal: {
    bgcolor: "#FFF",
    borderRadius: "30px",
    position: "absolute",
    left: "50%",
    top: "50%",
    width: { md: 600, sm: "calc(100% - 20px)" },

    transform: "translate(-50%,-50%)",
    py: 8.5,
    px: { md: 9.75, xs: 2 },
    "& button": {
      borderRadius: "10px",
      bgcolor: "#135099",
      fontSize: 16,
      fontWeight: 600,
      width: "100%",
      py: 1,
      mt: 5,
      textTransform: "capitalize",
      "&:hover": {
        bgcolor: "#135099",
      },
    },
  },
  cropContainer: {
    height: "48vh",
    width: { md: 450, xs: 300 },
    position: "relative",
    overflow: "hidden",
  },
  sliderBox: {
    mb: 1,
    mt: 3,
    "& svg": {
      width: 26,
      height: 26,
      color: "#135099",
    },
  },
  slider: {
    color: "#135099",
  },
};

const CropImage = ({
  modal,
  setModal,
  image,
  setUser,
  lessonIndex,
  ratio = 4 / 4,
  cropShape = "",
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);

  const [croppedArea, setCroppedArea] = useState();

  const avatarAspectRatio = 4 / 4;
  // const coverAspectRatio = 800 / 200;

  const handleClose = () => setModal(false);

  const handleCrop = async () => {
    const newImage = new Image();
    newImage.src = image;

    await new Promise((resolve) => {
      newImage.onload = resolve;
    });

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return null;
    }

    const { width: bBoxWidth, height: bBoxHeight } = newImage;

    canvas.width = bBoxWidth;
    canvas.height = bBoxHeight;

    ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
    ctx.scale(1, 1);
    ctx.translate(-newImage.width / 2, -newImage.height / 2);

    ctx.drawImage(newImage, 0, 0);

    const data = ctx.getImageData(
      croppedArea.x,
      croppedArea.y,
      croppedArea.width,
      croppedArea.height
    );

    const croppedCanvas = document.createElement("canvas");
    const croppedCtx = croppedCanvas.getContext("2d");

    if (!croppedCtx) {
      return null;
    }

    croppedCanvas.width = croppedArea.width;
    croppedCanvas.height = croppedArea.height;

    croppedCtx.putImageData(data, 0, 0);

    const croppedImageDataURL = croppedCanvas.toDataURL("image/png");

    const randomNum = Math.floor(1000 + Math.random() * 9000);

    setUser((prevUser) => {
      const newUser = { ...prevUser };

      if (modal === "avatar") {
        newUser.author_image = base64ToFile(
          croppedImageDataURL,
          `cropped-image-${randomNum}.png`
        );
      } else if (modal === "cover_image") {
        newUser.cover_image = base64ToFile(
          croppedImageDataURL,
          `cropped-image-${randomNum}.png`
        );
      } else if (
        modal === "lesson" &&
        lessonIndex >= 0 &&
        lessonIndex < newUser.lessons.length
      ) {
        newUser.lessons[lessonIndex].cover_image = base64ToFile(
          croppedImageDataURL,
          `cropped-image-${randomNum}.png`
        );
      } else if (modal === "eventDetail") {
        newUser.details.cover_image = base64ToFile(
          croppedImageDataURL,
          `cropped-image-${randomNum}.png`
        );
      } else if (modal === "eventSponsor") {
        newUser.image = base64ToFile(
          croppedImageDataURL,
          `cropped-image-${randomNum}.png`
        );
      } else if (modal === "company_logo") {
        newUser.company_logo = base64ToFile(
          croppedImageDataURL,
          `cropped-image-${randomNum}.png`
        );
      } else if (modal === "Resources") {
        newUser.company_logo = base64ToFile(
          croppedImageDataURL,
          `cropped-image-${randomNum}.png`
        );
      } else if (modal === "External Resources") {
        newUser.image = base64ToFile(
          croppedImageDataURL,
          `cropped-image-${randomNum}.png`
        );
      } else if (modal === "eventPost") {
        if (newUser.image.length === 0) {
          newUser.image[0] = base64ToFile(
            croppedImageDataURL,
            `cropped-image-${randomNum}.png`
          );
        } else {
          const Image = base64ToFile(
            croppedImageDataURL,
            `cropped-image-${randomNum}.png`
          );
          newUser.image.push(Image);
        }
      }

      // newUser.image = base64ToFile(
      //   croppedImageDataURL,
      //   `cropped-image-${randomNum}.png`
      // );
      // else if (modal === "eventPost") {
      //   newUser.image = base64ToFile(
      //     croppedImageDataURL,
      //     `cropped-image-${randomNum}.png`
      //   );
        // if (
        //   newUser.assets.length === 1 &&
        //   typeof newUser.assets[0].asset_url === "string"
        // ) {
        //   newUser.assets[0].asset_url = base64ToFile(
        //     croppedImageDataURL,
        //     `cropped-image-${randomNum}.png`
        //   );
        // } else {
        //   const newAsset = {
        //     asset_url: base64ToFile(
        //       croppedImageDataURL,
        //       `cropped-image-${randomNum}.png`
        //     ),
        //     asset_type: "image",
        //   };
        //   newUser.assets.push(newAsset);
        // }
      // }
      return newUser;
    });

    setModal(false);
  };

  function base64ToFile(base64Image, fileName) {
    const byteString = atob(base64Image.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: "image/jpeg" });

    return new File([blob], fileName, { type: "image/jpeg" });
  }

  useEffect(() => {
    if (!modal) {
      setZoom(1);
      setCrop({ x: 0, y: 0 });
    }
  }, [modal]);

  return (
    <Modal open={modal} onClose={handleClose} sx={styles}>
      <Box sx={styles.modal}>
        <Box sx={styles.cropContainer}>
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            zoomSpeed={4}
            maxZoom={4}
            zoomWithScroll={true}
            showGrid={false}
            // aspect={modal === "avatar" ? avatarAspectRatio : coverAspectRatio}
            aspect={ratio}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            cropShape={cropShape}
            onCropComplete={(croppedArea, croppedAreaPixels) => {
              setCroppedArea(croppedAreaPixels);
            }}
          />
        </Box>

        <Stack
          spacing={2}
          direction="row"
          sx={styles.sliderBox}
          alignItems="center"
        >
          <RemoveCircleOutlineOutlinedIcon />
          <Slider
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            aria-labelledby="zoom"
            onChange={(e, zoom) => setZoom(zoom)}
            sx={styles.slider}
          />
          <AddCircleOutlineOutlined />
          <Box component="div">{Math.round(zoom * 100)}%</Box>
        </Stack>

        <Button variant="contained" onClick={handleCrop}>
          Save
        </Button>
      </Box>
    </Modal>
  );
};

export default CropImage;
